import { createElement, lazy } from 'react'

import { routes } from '../routes'
import { registerRoute } from '../utils/routeRegistry'

const BusinessUnitBrandSelector = lazy(() => import('./components/businessUnitBrandsSelector'))

const initRoute = () => {
    registerRoute({
        path: routes.BUSINESS_UNIT_BRAND_SELECTOR + '/*',
        element: createElement(BusinessUnitBrandSelector),
    })
}

export default initRoute
